import "../../Stylesheet/Skill.css";
import { FiUsers } from "react-icons/fi";
import { IoCodeSlash } from "react-icons/io5";
import { MdOutlineColorLens } from "react-icons/md";
import { useContext } from "react";
import { LanguageContext } from "../../Context/LanguageContext";
import { CiGlobe } from "react-icons/ci";

export default function Skill() {

  const { t, lang } = useContext(LanguageContext);
  const s = t.skills;

  return (
    <section className="skills-section">
      {/* Header */}
      <div className="skills-header">
        <h2 className={lang === "ta" ? "h2-ta" : "h2-en"}>{s.title}</h2>
        <p>{s.subtitle}</p>
      </div>

      {/* Content */}
      <div className="skills-content">
        {/* Technical Skills */}
        <div className="skills-column">

          <div className="column-title">
            <IoCodeSlash className="blue" />
            <h3>{s.technical.title}</h3>
          </div>

          <div className="column-content">
            {s.technical.items.map((item, index) => (
              <SkillItem key={index} text={item} />
            ))}
          </div>

        </div>

        {/* Tools & Software */}
        <div className="skills-column">
          <div className="column-title">
            <MdOutlineColorLens className="purple" />
            <h3>{s.tools.title}</h3>
          </div>

          <div className="column-content">
            {s.tools.items.map((item, index) => (
              <SkillItem key={index} text={item} />
            ))}
          </div>

        </div>

        {/* Soft Skills */}
        <div className="skills-column">
          <div className="column-title">
            <FiUsers className="green" />
            <h3>{s.soft.title}</h3>
          </div>

          <div className="column-content">
            {s.soft.items.map((item, index) => (
              <SkillItem key={index} text={item} />
            ))}
          </div>

        </div>

        {/* Industry Knowledge */}
        <div className="skills-column">
          <div className="column-title">
            <CiGlobe className="orange" />

            <h3>{s.industry.title}</h3>
          </div>

          <div className="column-content">
            {s.industry.items.map((item, index) => (
              <SkillItem key={index} text={item} />
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}

/* Reusable Item */
function SkillItem({ text }) {
  return (
    <div className="skill-item">
      <span>{text}</span>
    </div>
  );
}
